const RESOURCE_NAME = '/user';

export default axios => ({
    getTypes(params) {
        return axios.get(`/sms-gateway/types`, {params});
    },
    findAll(userId, params) {
        return axios.get(`${RESOURCE_NAME}/${userId}/sms-gateway`, {params});
    },
    create(userId, data, params) {
        return axios.post(`${RESOURCE_NAME}/${userId}/sms-gateway`, data, {params});
    },
    update(userId, id, data, params) {
        return axios.put(`${RESOURCE_NAME}/${userId}/sms-gateway/${id}`, data, {params});
    },
    delete(userId, id, params) {
        return axios.delete(`${RESOURCE_NAME}/${userId}/sms-gateway/${id}`, {params});
    },
});
